<template>
  <div>
    <div v-if="logLine.subject.project">
      <i>
        {{ logLine.subject.project.name }}
      </i>
    </div>

    <div v-if="logLine.subject.user">
      <i class="text-muted">
        Responsible: {{ logLine.subject.user.full_name }}
      </i>
    </div>
  </div>
</template>

<script>
    export default {
        props: {logLine: {}}
    }
</script>
